/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import {
  Button,
  Dialog,
  Snackbar,
  Switch,
  Typography,
} from '@equinor/eds-core-react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CenteredLoader } from '../../components/CenteredLoader/CenteredLoader';
import { ModelTable } from '../../features/ModelTable/ModelTable';
import { SimulationTable } from '../../features/SimulationTable/SimulationTable';
import * as Styled from './Browse.styled';
import { useIsOwnerOrAdmin } from '../../hooks/useIsOwnerOrAdmin';
import { useModelFormStore } from '../../stores/ModelFormStore';
import { useExportStore } from '../../stores/ExportStore';
import { getFetchAnaloguesExcelAxios } from '../../hooks/useFetchAnaloguesExcel';
import * as StyledDialog from '../../styles/addRowDialog/AddRowDialog.styled';

export const Browse = () => {
  const setAnalogueModelDefault = useModelFormStore(
    (s) => s.setAnalogueModelDefault,
  );
  const exportModels = useExportStore((s) => s.exportModels);
  const isOwnerOrAdmin = useIsOwnerOrAdmin();
  const [uploadStatus, setUploadStatus] = useState<string>();
  const [isOpen, setIsOpen] = useState(false);
  const [allowDraft, setAllowDraft] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadFailed, setDownloadFailed] = useState(false);
  const [searchParams] = useSearchParams();
  const showSimulations = searchParams.get('tab') === 'simulations';

  useEffect(() => {
    setAnalogueModelDefault();
  }, [setAnalogueModelDefault]);

  function clearStatus() {
    setUploadStatus(undefined);
  }

  const navigate = useNavigate();

  function navigateAddModel() {
    navigate('/add-model');
  }

  const handleDownload = async () => {
    if (isDownloading) return;

    setIsDownloading(true);
    setDownloadFailed(false);
    try {
      await getFetchAnaloguesExcelAxios(exportModels, allowDraft);
      setIsOpen(false);
    } catch {
      setDownloadFailed(true);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <Styled.BrowseWrapper>
        {!showSimulations && (
          <>
            <ModelTable
              toolbarActions={
                <>
                  {isOwnerOrAdmin && (
                    <Button
                      disabled={!isOwnerOrAdmin}
                      onClick={navigateAddModel}
                    >
                      Add new model
                    </Button>
                  )}
                  <Button
onClick={() => {
                      setAllowDraft(false);
                      setDownloadFailed(false);
                      setIsOpen(true);
                    }}
                    disabled={isDownloading}
                    download
                  >
                    {exportModels.length === 0
                      ? 'Export all to Excel...'
                      : 'Export to Excel...'}
                  </Button>
                  {exportModels.length > 0 && (
                    <span>{exportModels.length} selected</span>
                  )}
                </>
              }
            />
          </>
        )}
        {showSimulations && <SimulationTable />}
      </Styled.BrowseWrapper>
      <Snackbar
        open={!!uploadStatus}
        autoHideDuration={15000}
        onClose={clearStatus}
      >
        {uploadStatus}
      </Snackbar>
      {isOpen && (
        <StyledDialog.DialogWindow open={isOpen}>
          <Dialog.Content>
            <Switch
              label="Include draft results"
              checked={allowDraft}
              disabled={isDownloading}
              onChange={(event) => setAllowDraft(event.target.checked)}
            />
            {isDownloading && (
              <div role="status" aria-label="Downloading Excel">
                <CenteredLoader size={24} text="Downloading excel" />
              </div>
            )}
            {downloadFailed && (
              <Typography role="alert">
                Excel download failed. Please try again.
              </Typography>
            )}
          </Dialog.Content>
          <StyledDialog.Actions>
            <Button
              onClick={handleDownload}
              disabled={isDownloading}
              aria-busy={isDownloading}
            >
              Download XSLX
            </Button>
            <Button
              variant="outlined"
              disabled={isDownloading}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </StyledDialog.Actions>
        </StyledDialog.DialogWindow>
      )}
    </>
  );
};
